import { baseApi } from 'api/base';
import { FindFnParams, PaginationResponse } from 'components/registry/types/api';
import { FeedRequestParams, FeedRegistryParams, FeedDto } from './params';

const findRequests = async (
  params: FindFnParams<FeedRequestParams>
): Promise<PaginationResponse<FeedDto>> => {
  const res = await baseApi.post('/list/pagedList', params);
  return res.data;
};

const findRegistry = async (
  params: FindFnParams<FeedRegistryParams>
): Promise<PaginationResponse<FeedDto>> => {
  const res = await baseApi.post('/list/pagedList', params);
  return res.data;
};

const deleteFeedRequest = async (id: string) => {
  await baseApi.delete(`/request/delete/${id}`);
};

export const feedApi = {
  findRequests,
  findRegistry,
  deleteFeedRequest,
};
